// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Box_gridBox__vFFFj {
  padding: 16px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
@media (max-width: 768px) {
  .Box_gridBox__vFFFj {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Box/Box.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AACF;AACE;EANF;IAOI,aAAA;IACA,sBAAA;IACA,SAAA;IACA,aAAA;EAEF;AACF","sourcesContent":[".gridBox {\n  padding: 16px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n\n  @media (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridBox": `Box_gridBox__vFFFj`
};
export default ___CSS_LOADER_EXPORT___;
